module.exports = __webpack_public_path__ + "img/filter.c19ecb8c.svg";